// Stylesheets first, and in this order — CSS lands in the bundle in module
// evaluation order, so this is what decides the cascade:
//   gentelella      the admin design system, lowest priority
//   <SFC styles>    injected by the component imports below; aktuaalne's own
//                   .btn / .card / .modal-title therefore beat gentelella's
//   app.scss        aktuaalne's :root and body win over gentelella's
//   admin-theme     re-asserts gentelella's tokens inside .admin-shell
import './assets/css/gentelella.scss'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import ElementPlusPlugin from './plugins/element-plus'
import MetaPlugin from './plugins/meta'
import CollapseTable from './components/table/collapse.vue'
import TableRow from './components/table/row.vue'
import BrandLogo from './components/BrandLogo.vue'
import Btn from './components/Button.vue'
import Badge from './components/Badge.vue'
import OverlayLoader from './components/OverlayLoader.vue'
import Modal from './components/modal/index.vue'
import EditForm from './components/form/index.vue'
import FormSection from './components/form/section.vue'
import Field from './components/form/field/Field.vue'
import CheckBox from './components/form/CheckBox.vue'
import './assets/css/app.scss'
import './assets/css/admin-theme.scss'

window.log = console.log.bind(console)

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(ElementPlusPlugin)
app.use(MetaPlugin)
app.component('CollapseTable', CollapseTable)
app.component('TableRow', TableRow)
app.component('BrandLogo', BrandLogo)
app.component('btn', Btn)
app.component('Badge', Badge)
app.component('OverlayLoader', OverlayLoader)
app.component('Modal', Modal)
app.component('EditForm', EditForm)
app.component('FormSection', FormSection)
app.component('Field', Field)
app.component('CheckBox', CheckBox)

app.mount('#app')
